module.exports = __webpack_public_path__ + "viasport-logo-black-ba02cfc8a6d92e73d81e4492572ff3bd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/viasport-logo-black.png
// module id = 997
// module chunks = 0 1 2